import { render } from "./DeviceInformation.vue?vue&type=template&id=40ad6796&scoped=true"
import script from "./DeviceInformation.vue?vue&type=script&lang=js"
export * from "./DeviceInformation.vue?vue&type=script&lang=js"

import "./DeviceInformation.vue?vue&type=style&index=0&id=40ad6796&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ad6796"]])

export default __exports__